// removed by extract-text-webpack-plugin
module.exports = {"result":"antd-pro-result","icon":"antd-pro-icon","success":"antd-pro-success","error":"antd-pro-error","title":"antd-pro-title","description":"antd-pro-description","extra":"antd-pro-extra","actions":"antd-pro-actions"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Result/index.less
// module id = 377
// module chunks = 0 1